import EnvService from '@services/internal/env';
import { useSyncExternalStore } from 'react';

function useEnvService() {
  const envs = useSyncExternalStore(EnvService.subscribe, EnvService.getSnapshot);

  return [envs, EnvService.setEnv] as const;
}

export default useEnvService;
